import { render, staticRenderFns } from "./Oss.vue?vue&type=template&id=3a978ae0&scoped=true&"
import script from "./Oss.vue?vue&type=script&lang=js&"
export * from "./Oss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a978ae0",
  null
  
)

export default component.exports